/* global process */

import QPXApi   from 'qpx-api'
import firebase from 'firebase'
import localDB  from 'localforage'
import moment   from 'moment'

firebase.initializeApp({
	apiKey:            process.env.REACT_APP_FIREBASE_apiKey,
	projectId:         process.env.REACT_APP_FIREBASE_projectId,
	messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId,
	authDomain:        process.env.REACT_APP_FIREBASE_domain,
	databaseURL:       process.env.REACT_APP_FIREBASE_database,
	storageBucket:     process.env.REACT_APP_FIREBASE_storage,
})
const fireDB = firebase.database()


class QPXApiWrap {

	constructor(api_key) {
		this.Api = new QPXApi({
			api_key: api_key,
			timeout: 5000
		})
	}

	getTrips(day_timestamp, callback){
		if ( +moment().startOf('day').format('X') > day_timestamp) {
			return
		}

		let ttl = 24*60*60
		this.cacheGet('trips_'+day_timestamp, ttl, (cache)=>{
			if (this.cacheIsValid(cache, ttl)) {
				callback( this.filterTrips(cache.data) )
				return
			}

			this.requestTrips(day_timestamp, (trips)=>{
				this.cacheSet('trips_'+day_timestamp, trips)
				
				callback( this.filterTrips(trips) )
			})
		})
	}

	
	/*
	 * QPX 
	 * docs: https://developers.google.com/qpx-express/v1/requests?hl=ru
	 **/
	requestTrips(day_timestamp, callback){
		let filters = {
			passengers: { adultCount: 1 },
			slice: [
				{
					origin: 'MOW',
					destination: 'LED',
					date: moment.unix(day_timestamp).format('YYYY-MM-DD')
				}
			],
			'solutions': 20
		}

		this.Api.search(filters).then((jsonResponse)=>{
			if (jsonResponse && jsonResponse.trips) {
				let trips = this.formatTrips(jsonResponse.trips)

				if (callback) { callback(trips) }
			}
		})
	}


	/*
	 * Firebase caching
	 */
	cacheSet(key, data){
		let cache_data = {
			time: +moment().format('X'),
			data: data,
		}

		localDB.setItem('cache_'+key, cache_data)
	
		try {
			console.log(key);
			console.log(cache_data);
			fireDB.ref('cache/' + key).set(cache_data)
		} catch(e) {
			console.error(e)
		}
	}
	cacheGet(key, ttl, callback){
		localDB.getItem('cache_'+key).then((cache)=>{
			if (this.cacheIsValid(cache, ttl)) {
				console.log('from local storage', cache)
				callback(cache)
				return
			}
	
			fireDB.ref('/cache/' + key).once('value').then((snapshot)=>{
				let fire_cache = snapshot.val()
				if (fire_cache) {
					localDB.setItem('cache_'+key, fire_cache)
				}
				callback( fire_cache )
			})
		})
	}

	cacheIsValid(cache, ttl){
		if (cache && cache.time+ttl > (+moment().format('X')) && cache.data) {
			return true
		}
		return false
	}



	formatTrips(source){
		let trips = []
		
		let airports = {}
		source.data.airport.forEach((a)=>{
			airports[a.code] = a.name
		})

		source.tripOption.forEach((item, i)=>{
			let trip = {}
			
			let info = {}
			try {
				info = item.slice[0].segment[0].leg[0]
			} catch(e) {
				return
			}

			let fields = ['arrivalTime','departureTime','origin','destination','duration']
			fields.forEach((field)=>{
				if (info[field]) {
					trip[field] = info[field]
				}
			})

			trip.from = airports[trip.origin]+', '+trip.origin
			trip.to   = airports[trip.destination]+', '+trip.destination

			let prices = []
			
			try {
				if (item.saleTotal) {
					prices.push( item.saleTotal )
				}
				if (item.pricing[0].baseFareTotal) {
					prices.push( item.pricing[0].baseFareTotal )
				}
				if (item.pricing[0].tax[0].salePrice) {
					prices.push( item.pricing[0].tax[0].salePrice )
				}
			} catch(e) {
				// 
			}
			
			trip.prices = prices

			trips.push(trip)
		})

		return this.sortTrips(trips)
	}

	sortTrips(trips){
		trips.sort(function(a,b) {
			let t1 = +moment(a.departureTime).format('X')
			let t2 = +moment(b.departureTime).format('X')
			if ( t1 < t2 ){
				return -1
			}
			if ( t1 > t2 ){
				return 1
			}
			return 0
		})

		return trips
	}

	filterTrips(trips){
		trips.filter((trip)=>{
			return +moment(trip.departureTime).format('X') > +moment().format('X')
		})
		return trips
	}


	getDaysInfo(days, callback){
		for(let k in days){
			days[k].min_price = '+'+((''+days[k].timestamp).split('').splice(4,4).join(''))
		}
		callback(days)
	}

}

const Api = new QPXApiWrap(process.env.REACT_APP_QPX_API_KEY)
export default Api


// WEBPACK FOOTER //
// ./src/Api.js